import type { ThemePreference } from '@karya/core';

const media = () => window.matchMedia('(prefers-color-scheme: dark)');
let current: ThemePreference = 'light';

function apply(): void {
  const dark = current === 'dark' || (current === 'system' && media().matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  const meta =
    document.querySelector('meta[name="theme-color"]:not([media])') ??
    (() => {
      const m = document.createElement('meta');
      m.name = 'theme-color';
      document.head.appendChild(m);
      return m;
    })();
  meta.setAttribute('content', dark ? '#0f1516' : '#ffffff');
}

/** Apply the theme preference; "system" follows the OS setting live. */
export function setTheme(pref: ThemePreference): void {
  current = pref;
  try {
    localStorage.setItem('karya-theme', pref);
  } catch {
    /* storage may be unavailable */
  }
  apply();
}

export function initTheme(): void {
  try {
    const saved = localStorage.getItem('karya-theme') as ThemePreference | null;
    if (saved === 'light' || saved === 'dark' || saved === 'system') current = saved;
  } catch {
    /* ignore */
  }
  apply();
  media().addEventListener('change', apply);
}

export function getTheme(): ThemePreference {
  return current;
}
